import { useMutation } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { reprocessOrderFn } from "@/api/ordersApi"
import { showToast } from "@/shared/utils"

export const useReprocessOrder = () =>
  useMutation(reprocessOrderFn, {
    onError: (error) => {
      if (!isAxiosError(error)) {
        return
      }

      const message =
        error.response?.data?.errorMessage ||
        error.response?.data?.message ||
        error.message

      if (error.response?.status === 404) {
        showToast({ type: "error", text: "Order not found." })
        return
      }

      if (error.response?.status === 403) {
        showToast({
          type: "error",
          text: message || "Order reprocess is not enabled for this organization.",
        })
        return
      }

      if (error.response?.status === 400) {
        showToast({ type: "error", text: message })
        return
      }

      showToast({ type: "error", text: message })
    },
  })
